import getStore from 'services/getStore';
import { cloneBlock } from '@chameleoncreator/creator-app';
import { setBlockAction } from 'store/next';

let newBlocks = {};
let delayUpdate;

export default (block, props) => {
  // const newBlock = cloneBlock(block);
  // newBlock.props = { ...newBlock.props, ...props };

  // return getStore().dispatch(setBlockAction(newBlock));

  if (!newBlocks[block.id]) {
    newBlocks[block.id] = cloneBlock(block);
  }

  newBlocks[block.id].props = { ...newBlocks[block.id].props, ...props };

  clearTimeout(delayUpdate);
  delayUpdate = setTimeout(() => {
    // console.log('WOW !!!', newBlocks);
    Object.values(newBlocks).forEach((b: any) => {
      getStore().dispatch(setBlockAction(b));
    });
    newBlocks = {};
  }, 1000 / 60);
};
